import { render, staticRenderFns } from "./AlertPushList.vue?vue&type=template&id=f5ed7190&scoped=true&"
import script from "./AlertPushList.vue?vue&type=script&lang=js&"
export * from "./AlertPushList.vue?vue&type=script&lang=js&"
import style0 from "./AlertPushList.vue?vue&type=style&index=0&id=f5ed7190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ed7190",
  null
  
)

export default component.exports